// start:ng42.barrel
export * from './bpg-image.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/bpg-image/index.ts